import React from 'react';
import { Box, Typography, Container } from '@mui/material';

export const QuestionnaireExitedPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          p: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: '#3A7380',
            fontWeight: 700,
            fontFamily: '"Open Sans", sans-serif',
            mb: 3,
          }}
        >
          You've exited the screening
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#5A7380',
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '1.1rem',
            lineHeight: 1.6,
          }}
        >
          If you'd like to continue later, you can return using the link we emailed you.
        </Typography>
      </Box>
    </Container>
  );
};
